import React from 'react';
import PropTypes from 'prop-types';

const Radio = ({ checked, className, disabled, id, name, value, onChange, required }) => (
  <div className={`relative w-4 h-4 flex-none ${className || ''}`}>
    <input
      type="radio"
      name={name}
      value={value}
      checked={checked}
      disabled={disabled}
      id={id}
      onChange={onChange}
      required={required}
      className="peer absolute inset-0 opacity-0 cursor-pointer z-10 disabled:cursor-not-allowed"
    />
    {/* Outer ring */}
    <div 
      className={`absolute inset-0 rounded-full border-2 transition-all duration-200 peer-disabled:opacity-50 peer-disabled:grayscale-[0.25] ${
        checked ? 'border-[#4055b3]' : 'border-[#ced4da]'
      } peer-checked:border-[#4055b3]`} 
    />
    {/* Inner dot (Fixed offset centering to avoid transform conflicts) */}
    <div 
      className={`absolute top-[5px] left-[5px] w-[6px] h-[6px] bg-[#4055b3] rounded-full transition-all duration-300 transform pointer-events-none ${
        checked ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
      } peer-checked:scale-100 peer-checked:opacity-100`} 
    />
  </div>
);

Radio.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
};

Radio.defaultProps = {
  checked: false,
  className: null,
  disabled: false,
  onChange: null,
  required: false,
};

export default Radio;
